module.exports = {"data":{"site":{"siteMetadata":{"title":"Gatsby + Netlify CMS Starter"}},"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/blog/2017-01-05-using-git-for-docs/"},"frontmatter":{"title":"Using Git for Docs"}}}]}},"pathContext":{"tag":"git"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-git.json
// module id = 364
// module chunks = 224989948613620